/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ dateFrom: NonNullable<unknown>, dateTo: NonNullable<unknown> }} Dashboard_This_MonthInputs */

const vi_dashboard_this_month = /** @type {(inputs: Dashboard_This_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tháng này — ${i?.dateFrom} đến ${i?.dateTo}`)
};

/**

* @param {Dashboard_This_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_this_month = /** @type {((inputs: Dashboard_This_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_This_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_this_month(inputs)
});